import { styled } from '@mui/material/styles';
import { Grid2 } from '../grid-2';

export const Wrapper = styled(Grid2)``;
